function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var d = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty,
    v = Object.prototype.propertyIsEnumerable;

var n = function n(o, e, l) {
  return e in o ? d(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : o[e] = l;
},
    i = function i(o, e) {
  for (var l in e || (e = {})) {
    p.call(e, l) && n(o, l, e[l]);
  }

  if (t) {
    var _iterator = _createForOfIteratorHelper(t(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        v.call(e, l) && n(o, l, e[l]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as r from "react";

function C(o) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), r.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5607 15.5607C16.9749 16.1464 16.0251 16.1464 15.4393 15.5607L11.5 11.6213L7.5607 15.5607C6.9749 16.1464 6.0251 16.1464 5.4393 15.5607C4.8536 14.9749 4.8536 14.0251 5.4393 13.4393L10.4393 8.4393C11.0251 7.8536 11.9749 7.8536 12.5607 8.4393L17.5607 13.4393C18.1464 14.0251 18.1464 14.9749 17.5607 15.5607Z",
    fill: "black"
  }));
}

export { C as ReactComponent };